(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
  window.addYarnioProductToCart = function(variantId, btnElement) {
    if (!variantId) {
      if (btnElement) {
        const originalHtml = btnElement.innerHTML;
        btnElement.classList.add('is-added');
        btnElement.innerHTML = `
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        `;
        setTimeout(() => {
          btnElement.classList.remove('is-added');
          btnElement.innerHTML = originalHtml;
        }, 1000);
      }
      return;
    }

    const originalHtml = btnElement ? btnElement.innerHTML : '';

    // 1. Instant 0ms Visual Feedback on Button
    if (btnElement) {
      btnElement.classList.add('is-added');
      btnElement.disabled = true;
      btnElement.innerHTML = `
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
      `;
    }

    // 2. Instant 0ms Cart Badges Increment (Header & Bottom Bar)
    const badges = document.querySelectorAll('#yarnio-cart-count, .yarnio-header__cart-count, #yarnio-bottom-cart-count');
    badges.forEach(badge => {
      const current = parseInt(badge.innerText || '0', 10);
      badge.innerText = current + 1;
      badge.style.display = (badge.id === 'yarnio-bottom-cart-count' ? 'block' : 'flex');
      badge.style.transform = 'scale(1.3)';
      setTimeout(() => { badge.style.transform = 'scale(1)'; }, 150);
    });

    // 3. Instant 0ms Cart Drawer Opening
    // Drawer starts sliding immediately, completely masking the network roundtrip behind the 350ms animation
    if (window.openYarnioCartDrawer) {
      window.openYarnioCartDrawer(true);
    }

    // 4. Parallel API Dispatch
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(res => {
      if (!res.ok) throw new Error('Failed to add product to cart');
      return res.json();
    })
    .then(data => {
      // Refresh drawer with updated cart from server
      if (window.refreshYarnioCart) {
        window.refreshYarnioCart();
      }

      if (btnElement) {
        setTimeout(() => {
          btnElement.classList.remove('is-added');
          btnElement.innerHTML = originalHtml;
          btnElement.disabled = false;
        }, 900);
      }
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
      if (btnElement) {
        btnElement.classList.remove('is-added');
        btnElement.innerHTML = originalHtml;
        btnElement.disabled = false;
      }
      if (window.refreshYarnioCart) {
        window.refreshYarnioCart();
      }
    });
  };

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  window.toggleYarnioDrawer = function() {
    const drawer = document.getElementById('yarnio-mobile-drawer');
    const toggleBtn = document.querySelector('.yarnio-header__toggle');
    if (!drawer) return;
    const isOpen = drawer.classList.contains('yarnio-mobile-drawer--open');
    if (isOpen) {
      drawer.classList.remove('yarnio-mobile-drawer--open');
      drawer.setAttribute('aria-hidden', 'true');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    } else {
      drawer.classList.add('yarnio-mobile-drawer--open');
      drawer.setAttribute('aria-hidden', 'false');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    const toggleBtn = document.querySelector('.yarnio-header__toggle');
    const closeBtn = document.querySelector('.yarnio-mobile-drawer__close');
    const overlay = document.querySelector('.yarnio-mobile-drawer__overlay');
    
    if (toggleBtn) {
      toggleBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.toggleYarnioDrawer();
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        window.toggleYarnioDrawer();
      });
    }
    if (overlay) {
      overlay.addEventListener('click', () => {
        window.toggleYarnioDrawer();
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
